const locationHref = window.location.href;
const isTesting = locationHref.indexOf('localhost') >= 0;
const isStaging = locationHref.indexOf('staging') >= 0;
const isSandbox = locationHref.indexOf('sandbox') >= 0;
const ENVIRONMENT = isTesting ? 'TESTING' : isStaging || isSandbox ? 'STAGING' : 'PRODUCTION';

const envVars = window._env_ || process.env; // Test runs populate using process.env

export default {
    ENVIRONMENT,
    AWS_ENV_REGION: envVars.AWS_ENV_REGION,
    NODE_ENV: envVars.NODE_ENV,
    publicUrl: envVars.PUBLIC_URL,
    reactAppPreview: envVars.REACT_APP_PREVIEW === 'true',
    reactAppVersion: envVars.REACT_APP_VERSION,
    convertHtml: `${envVars.CREATE_SERVICE}/pikasso/convert/html`,
    versionHistory: `${envVars.CREATE_SERVICE}/pikasso/version/history`,
    versionHistoryItem: `${envVars.CREATE_SERVICE}/pikasso/version/history/item`,
    getClientIP: `${envVars.CREATE_SERVICE}/common/clientip`,
    emailDesignerAPI: envVars.SERVICE_EMAIL_DESIGNER,
    uploadImageByLink: `${envVars.CREATE_SERVICE}/pikasso/upload/image/link`,
    uploadImageByContent: `${envVars.CREATE_SERVICE}/pikasso/upload/image/content`,
    getUserData: `${envVars.CREATE_SERVICE}/pikasso/user/data`,
    downloadPdf: `${envVars.CREATE_SERVICE}/pikasso/pdf`,
    getAccountCustomFontFamilies: `${envVars.CREATE_SERVICE}/pikasso/font/account`,
    getCustomFontFamily: `${envVars.CREATE_SERVICE}/pikasso/font/family`,
    getCustomFont: `${envVars.CREATE_SERVICE}/pikasso/font`,
    memberSiteBrandingUrl: `${envVars.WEB_APP}/settings/branding`,
    launchDarkly: envVars.LAUNCH_DARKLY,
    websockets: envVars.REALTIME,
    postPikassoFeedback: `${envVars.CREATE_SERVICE}/pikasso/slack/feedback`,
    contentLibraryEndpoint: `${envVars.CREATE_SERVICE}/pikasso/content/library`,
    contentLibraryEndpointRename: `${envVars.CREATE_SERVICE}/pikasso/content/library/rename`,
    contentLibraryFolder: `${envVars.CREATE_SERVICE}/pikasso/content/library/folder`,
    updateFolder: `${envVars.CREATE_SERVICE}/pikasso/content/library/folder`,
    youtubeAPIKey: envVars.YOUTUBE_API_KEY,
    fullStoryOrgID: envVars.FULL_STORY_ORG_ID,
    fullStoryEnabled: envVars.FULL_STORY_ENABLED === 'true',
    datadogEnabled: envVars.DATADOG_ENABLED === 'true' && !isTesting,
    pendoEnabled: envVars.PENDO_ENABLED === 'true',
    staffbasePosts: `${envVars.CREATE_SERVICE}/sb/posts`,
    staffbaseBranch: `${envVars.CREATE_SERVICE}/sb/config`,
    ldPendoCheck: `${envVars.CREATE_SERVICE}/common/launchdarkly/pendo`,
    personalizationTag: `${envVars.CREATE_SERVICE}/personalization/tag`,
    singleUsePersonalizationTags: `${envVars.MEMBER_SITE_BE_URL}/templates/personalization`,
};
